import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { canAccess } from "../../utils/permissions";

const UnauthorizedPage = () => {
  const userData = useSelector((state: RootState) => state.user.userData);
  const userId = userData?.user_id ?? "";

  const backToPath = (() => {
    if (userId && canAccess(userData, "user_list")) {
      return `/active-users/${userId}`;
    }
    if (canAccess(userData, "current_bets")) {
      return "/current-bets";
    }
    if (canAccess(userData, "account_statement")) {
      return "/account-statement";
    }
    return "/";
  })();

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body text-center">
              <h1 className="display-4 font-weight-bold mb-2">403</h1>
              <h4 className="text-uppercase mb-3">
                You don&apos;t have permission to access this page
              </h4>
              <p className="mb-3">
                Please go back to a page that is available for your account.
              </p>
              <Link to={backToPath} className="btn btn-primary">
                Back to Dashboard
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
